import axios from 'axios';
import router from './router';

const api = axios.create({
  baseURL: '/',
  // CRITICAL: This tells the browser to send the session cookie 
  // with every request to your Flask backend.
  withCredentials: true 
});

// Response Interceptor
api.interceptors.response.use(
  (response) => {
    // Return the response if everything is fine
    return response;
  },
  (error) => {
    const originalRequest = error.config;

    // 1. If we get a 401 and we aren't already on the login page
    // we redirect to login because the session has likely expired.
    if (error.response && error.response.status === 401) {
      
      // Don't redirect if the error came FROM the login attempt itself
      if (!originalRequest.url.includes('/api/login')) {
        // Optional: Clear any local auth state here if you have a store
        router.push('/login');
      }
    }

    // Pass the error back to the calling component (like Login.vue) 
    // so it can show a "Wrong password" message.
    return Promise.reject(error);
  }
);

export default api;
